import React from 'react';
import PropTypes from 'prop-types';
import styles from './Badge.module.sass';
import ClickableDiv from '../clickable_div/ClickableDiv';

function Badge(props) {
  const {
    color, text, onClick, badgePosition, className: classNameFromProps,
  } = props;

  const className = `${styles.badge} ${styles[badgePosition]} ${styles[color]} ${classNameFromProps}`;

  return (
    <>
      { onClick && (
        <ClickableDiv className={className} onClick={onClick}>
          {text}
        </ClickableDiv>
      )}

      { !onClick && (
        <div className={className}>
          {text}
        </div>
      )}
    </>
  );
}

Badge.propTypes = {
  color: PropTypes.oneOf([
    'yellow', 'blue', 'green', 'red',
  ]),
  text: PropTypes.string.isRequired,
  badgePosition: PropTypes.oneOf([
    'left', 'right',
  ]),
  onClick: PropTypes.func,
  className: PropTypes.string,
};

Badge.defaultProps = {
  color: 'yellow',
  badgePosition: 'left',
  onClick: null,
  className: null,
};

export default Badge;
